import { SavedHotelData } from 'tripPlanner/types/tripItem'
import {
  CreateHotelRequestBody,
  getBedbankCheckInOutTime,
} from 'tripPlanner/utils/itemConversions/common'

interface Params {
  offer: App.BedbankOffer
  pkg: App.BedbankPackage
  rate: App.BedbankRate
  rooms: App.Occupants[]
  checkIn: string
  checkOut: string
  currentRegionCode: string
  currencyCode: string
}

export function createBedbankHotelItemPayload({
  offer,
  pkg,
  rate,
  rooms,
  checkIn,
  checkOut,
  currentRegionCode,
  currencyCode,
}: Params): CreateHotelRequestBody {
  const savedHotelData: SavedHotelData = {
    offerType: offer.type,
    currencyCode,
    offerId: offer.id,
    packageId: pkg.roomId,
    checkIn,
    checkOut,
    rateId: rate.id,
    occupancies: rooms,
    price: rate.totals.inclusive,
    value: rate.value,
    discountPercent: rate.discount * 100,
    roomTypeName: pkg.name,
    priceDisplayType: 'taxesAndFeesInclusive',
    regionCode: currentRegionCode,
  }

  const [checkInTime, checkOutTime] = getBedbankCheckInOutTime(
    offer.property.finePrint,
  )

  const payload: CreateHotelRequestBody = {
    type: 'HOTEL',
    isBooked: false,
    sourceType: 'LE_Hotel_Bedbank',
    startDate: checkIn,
    endDate: checkOut,
    startTime: checkInTime,
    endTime: checkOutTime,
    place: {
      type: 'GEO_MULTI_DATES',
      id: offer.property.id,
      address: offer.property.address.line1,
      name: offer.name,
      point: {
        lat: offer.property.latitude,
        lng: offer.property.longitude,
      },
    },
    code: offer.id,
    subCode: rate.roomId,
    savedItemData: savedHotelData,
  }

  return payload
}
